import {inject} from '@angular/core';
import {RedirectCommand, ResolveFn, Router} from '@angular/router';
import {from, isObservable} from 'rxjs';
import {map} from 'rxjs/operators';

export function withFlag<T>(
  resolver: ResolveFn<T | RedirectCommand>,
  hasFlag: (data: T) => boolean,
): ResolveFn<T | RedirectCommand> {
  return (route, state) => {
    const router = inject(Router);

    const result = resolver(route, state);
    const result$ = isObservable(result) ? result : from(Promise.resolve(result));

    return result$.pipe(
      map(value => {
        // Bypass redirects
        if (value instanceof RedirectCommand) {
          return value;
        }

        // Check if null
        if (!value || !hasFlag(value)) {
          return new RedirectCommand(router.createUrlTree(['/pde-guest']));
        }

        return value;
      }),
    );
  };
}
